import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Camera, ArrowRight } from "lucide-react";

const rise = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.55, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Kegiatan() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data.filter((n) => n.category === "Kegiatan"))).catch(() => {});
  }, []);

  return (
    <div data-testid="kegiatan-page">
      <PageHeader title="Kegiatan BPBD" subtitle="Dokumentasi pelatihan, simulasi, sosialisasi, dan aksi lapangan BPBD Kabupaten Kayong Utara" />
      <section className="max-w-7xl mx-auto px-4 py-16">
        {items.length === 0 ? (
          <div className="border-2 border-dashed border-slate-200 rounded-xl p-16 text-center text-slate-400" data-testid="kegiatan-page-empty">
            <Camera className="mx-auto mb-3" size={32} />
            Belum ada dokumentasi kegiatan. Admin dapat menambahkannya melalui menu "Berita & Kegiatan" dengan kategori Kegiatan.
          </div>
        ) : (
          <div className="space-y-8">
            {items.map((k, i) => (
              <motion.div key={k.id} custom={i % 3} initial="hidden" whileInView="show" viewport={{ once: true }} variants={rise}>
                <Link
                  to={`/berita/${k.id}`}
                  className={`group hover-lift grid md:grid-cols-5 border border-slate-200 bg-white rounded-xl overflow-hidden hover:border-sky-400 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
                  data-testid={`kegiatan-item-${k.id}`}
                >
                  {k.image_url && (
                    <div className="md:col-span-2 overflow-hidden [direction:ltr]">
                      <img src={k.image_url} alt={k.title} className="w-full h-56 md:h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className={`${k.image_url ? "md:col-span-3" : "md:col-span-5"} p-8 lg:p-10 [direction:ltr]`}>
                    <p className="font-mono text-xs text-slate-400">{new Date(k.created_at).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</p>
                    <h2 className="font-heading text-lg md:text-2xl font-bold text-slate-900 mt-3 group-hover:text-sky-600 transition-colors">{k.title}</h2>
                    <p className="text-slate-500 text-sm md:text-base mt-3 line-clamp-3">{k.content}</p>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold text-orange-600 mt-5 group-hover:gap-3 transition-all">
                      Baca Selengkapnya <ArrowRight size={15} />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
